<template>
  <div class="container-fixed">
    <h3>date-fns formats</h3>
    <dl class="list-desc-grid list-desc-semibold">
      <template v-for="item in items">
        <dt :key="'dt' + item.name">{{ item.name }}</dt>
        <dd :key="'dd' + item.name"
          >{{ item.output }} <small>{{ item.format }}</small></dd
        >
      </template>
    </dl>
    <hr />
    <h3>Parsed and localized</h3>
    <dl class="list-desc-grid list-desc-semibold">
      <dt>dateTimeFormat</dt>
      <dd
        >{{ parsedDateTimeFormat }} <small>{{ $t('common.dateTimeFormat') }}</small></dd
      >
      <dt>dateFormat</dt>
      <dd
        >{{ parsedDateFormat }} <small>{{ $t('common.dateFormat') }}</small></dd
      >
      <dt>dateUrlFormat</dt>
      <dd>{{ parsedUrlFormat }}</dd>
    </dl>
  </div>
</template>

<script>
import format from 'date-fns/format';
import parse from 'date-fns/parse';

import * as formats from '@/utils/date';

export default {
  name: 'TestDate',

  data() {
    const supported = ['dateInputPeriodFormat', 'dateTimeTransferFormat', 'tableDateTimeOutputFormat'];
    const items = Object.keys(formats)
      .filter(name => supported.includes(name))
      .map(name => ({ name, format: formats[name], output: format(new Date(), formats[name]) }));
    return {
      parsedDateTimeFormat: format(parse('2018-06-25T01:12:23+0000', formats.dateTimeInputFormat, new Date()), this.$t('common.dateTimeFormat')),
      parsedDateFormat: format(parse('2018-06-25', formats.dateInputFormat, new Date()), this.$t('common.dateFormat')),
      parsedUrlFormat: format(parse('2018-06-25', formats.dateUrlFormat, new Date()), this.$t('common.dateFormat')),
      items,
    };
  },
};
</script>

<style scoped>
small {
  color: #999;
}
</style>
